type ComparisonResult = {
  new?: any[] | { [key: string]: any };
  remove?: any[] | { [key: string]: any };
};

function compareArray(array1: any[], array2: any[]): ComparisonResult {
  const result: ComparisonResult = {
    new: [],
    remove: [],
  };

  result.new = array2.filter((arr2) => !array1.includes(arr2));
  result.remove = array1.filter((arr1) => !array2.includes(arr1));

  return result;
}

export default compareArray;
